import { formatIncompletePhoneNumber, isValidNumberForRegion, parseIncompletePhoneNumber } from 'libphonenumber-js'
import { useCallback, useLayoutEffect, useMemo, useRef } from 'react'

export function usePhoneNumberState(value, onChangeText) {
  const phoneNumber = useMemo(() => formatIncompletePhoneNumber(value, 'US'), [value])
  const refPrevValue = useRef(phoneNumber)
  useLayoutEffect(() => {
    refPrevValue.current = phoneNumber
  }, [phoneNumber])
  const onChangePhoneNumber = useCallback((phoneNumber = '') => {
    let newValue = phoneNumber ? parseIncompletePhoneNumber(phoneNumber) : ''
    if (newValue) {
      const newPhoneNumber = formatIncompletePhoneNumber(newValue, 'US')
      const prevPhoneNumber = refPrevValue.current
      const isFormatChanges = newPhoneNumber === prevPhoneNumber &&
        prevPhoneNumber.startsWith(phoneNumber) &&
        phoneNumber.length < prevPhoneNumber.length
      if (isFormatChanges) {
        newValue = newValue.substr(0, newValue.length - 1)
      }
    }
    onChangeText(newValue)
  }, [refPrevValue, onChangeText])
  return [phoneNumber, onChangePhoneNumber, isValidNumberForRegion(phoneNumber, 'US')]
}
